import { CalendarDate, Day } from "@gemma/dates";
import { DateRelativeTo, EntryPeriod } from "@gemma/utils";

import { datePickerDateEnabled } from "./datePickerDateEnabled";

// Tod: CHECK ALL THIS
export function getDisabledDates(
  //
  this: {
    recruitmentAgencySettings: {
      defaults: {
        dateRelativeTo: DateRelativeTo;
        timesheetWeekStartsOn: Day;
      };
    };
  },
  contractor?: {
    entryPeriod: EntryPeriod;
    start?: Readonly<CalendarDate>;
    end?: Readonly<CalendarDate>;
  }
) {
  if (contractor && contractor.start) {
    const recruitmentAgencyDefaultSettings = this.recruitmentAgencySettings.defaults;

    let periodStartDate: Readonly<CalendarDate> | undefined;
    if (contractor.entryPeriod.isWeekly) {
      periodStartDate = recruitmentAgencyDefaultSettings.dateRelativeTo.isBeginning ? contractor.start.previous(recruitmentAgencyDefaultSettings.timesheetWeekStartsOn) : contractor.start;
    } else if (contractor.entryPeriod.isCalendarMonthly) {
      periodStartDate = contractor.start.toFirstDateOfMonth;
    }

    let periodEndDate: Readonly<CalendarDate> | ((calendarDate: Readonly<CalendarDate>) => Readonly<CalendarDate>) | undefined = undefined;
    const _periodEndDate = contractor.end && CalendarDate.parse(contractor.end);
    if (recruitmentAgencyDefaultSettings.dateRelativeTo.isEnding) {
      if (contractor.entryPeriod.isWeekly) {
        if (_periodEndDate) {
          periodEndDate = _periodEndDate.next(recruitmentAgencyDefaultSettings.timesheetWeekStartsOn);
        } else {
          periodEndDate = (calendarDate: Readonly<CalendarDate>) => (calendarDate.day.id === recruitmentAgencyDefaultSettings.timesheetWeekStartsOn.id ? calendarDate.clone() : calendarDate.next(recruitmentAgencyDefaultSettings.timesheetWeekStartsOn));
        }
      } else if (contractor.entryPeriod.isCalendarMonthly) {
        periodEndDate = _periodEndDate ? (_periodEndDate as Readonly<CalendarDate>).toLastDateOfMonth : date => date.toLastDateOfMonth;
      }
    } else {
      periodEndDate = _periodEndDate;
    }

    // disable dates from- the end date is exclusive (at least from CalendarDate perspective) so push it to the end of the day
    let from = undefined;
    if (periodEndDate && typeof periodEndDate !== "function") {
      from = periodEndDate.asDate;
      from.setHours(23);
      from.setMinutes(59);
      from.setSeconds(59);
    }

    return {
      // disable dates to
      to: periodStartDate && periodStartDate.asDate,
      from,
      customPredictor: (date: Date) => {
        const isDisabled = !datePickerDateEnabled(date, contractor, recruitmentAgencyDefaultSettings, { periodStartDate, periodEndDate });

        return isDisabled;
      },
    };
  } else {
    return {
      customPredictor: () => true,
    };
  }
}
